<template>
  <div>
    <div class="br-pagetitle d-flex justify-content-between align-items-center">
      <div class="d-flex align-items-center">
        <i class="icon ion-grid"></i>
        <div class="mg-l-20">
          <h4>
            {{ $t("warehouse.货架管理") }}
            <span v-if="warehouseName" class="mg-l-5 tx-16"
              >( {{ warehouseName }} )</span
            >
          </h4>
        </div>
      </div>
      <div class="tx-right">
        <button
          class="btn btn-success"
          v-if="isSysRights('Warehouse.addShelf')"
          @click="openEditShelf(1)"
        >
          {{ $t("warehouse.添加货架") }}
        </button>
      </div>
    </div>
    <div
      class="d-flex align-items-center justify-content-start pd-x-20 pd-sm-x-30"
    >
      <div class="clear-key">
        <a
          v-show="keyId"
          href="javascript:;"
          class="mg-r-15"
          @click="clearKey('keyId')"
        >
          {{ $t("warehouse.货架编号：") }}
          <span class="mg-r-10">{{ keyId }}</span>
          <i class="fa fa-close"></i>
        </a>
        <a
          v-show="keyName"
          href="javascript:;"
          class="mg-r-15"
          @click="clearKey('keyName')"
        >
          {{ $t("warehouse.货架名称：") }}
          <span class="mg-r-10">{{ keyName }}</span>
          <i class="fa fa-close"></i>
        </a>
        <a
          v-show="keyPosition"
          href="javascript:;"
          class="mg-r-15"
          @click="clearKey('keyPosition')"
        >
          {{ $t("warehouse.仓位编号：") }}
          <span class="mg-r-10">{{ keyPosition }}</span>
          <i class="fa fa-close"></i>
        </a>
        <a
          v-show="keyStatus"
          href="javascript:;"
          class="mg-r-15"
          @click="clearKey('keyStatus')"
        >
          {{ $t("warehouse.状态：") }}
          <span class="mg-r-10">{{ $t($dict.shelfStatus[keyStatus]) }}</span>
          <i class="fa fa-close"></i>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["keyId", "keyName", "keyStatus", "keyPosition", "warehouseName"],
  methods: {
    openEditShelf(type) {
      this.$emit("openEditShelf", type);
    },
    clearKey(type) {
      this.$emit("clearKey", type);
    },
  },
};
</script>
